import AiLabel from "@/components/ai-label";
import { CustomCategory } from "@/components/category";
import LinkedContent from "@/components/linked-content";
import PodcastPlayButton from "@/components/podcast-play-button";
import TeaserHeading from "@/components/teaser-heading";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

type MediumProps = {
  podcast: Content.PodcastEpisode;
  hideDownPull?: boolean;
  showLinkedContent?: boolean;
};

const Medium = (props: MediumProps) => {
  const podcastShow = props.podcast.fields["podcast-show"];
  const hasLinkedContent = Boolean(props.podcast.fields.linkedContent?.length);
  const category = props.podcast.fields.categories?.[0];
  const parentCategory = category?.fields.parentCategory;
  const color = category?.fields.color || parentCategory?.fields.color;
  const image =
    props.podcast.fields.teaserImage || props.podcast.fields.image;
  const title =
    props.podcast.fields.teaserTitle || props.podcast.fields.title;

  return (
    <LinkedContent
      linkedContent={props.podcast.fields.linkedContent}
      color={color}
      showLinkedContent={props.showLinkedContent}
      compactMode={true}
    >
      <Link
        href={`/podd/${props.podcast.fields.slug}`}
        className={classNames(
          "cursor-pointer group block relative pb-4 border-b border-sand-800",
          {
            "!pb-2": hasLinkedContent,
          },
        )}
      >
        {image?.fields.file?.url && (
          <div className="aspect-w-1 aspect-h-1 mb-4">
            <Image
              fill
              src={createImageUrl(image.fields.file.url, {
                crop: "1:1",
              })}
              alt={image.fields.alt || ""}
              className="object-cover"
              sizes={createImageSizes({
                mobile: "100vw",
                tablet: "50vw",
                desktop: "33vw",
              })}
            />
            <AiLabel image={image} />
          </div>
        )}

        {podcastShow && (
          <CustomCategory color="Podd" name={podcastShow.fields.title} />
        )}

        {title && (
          <TeaserHeading
            text={title}
            className="text-xl font-semibold mb-2"
          />
        )}

        {props.podcast.fields.media?.mediaUrl && (
          <PodcastPlayButton podcast={props.podcast} />
        )}
      </Link>
    </LinkedContent>
  );
};

export default Medium;
